import { writeData } from "../../../api";
import { newNotePageBlock } from "../../../types/notebook/note/block/page";
import { useAppIdMap } from "../../app";
import { useInsertBlock } from "../block";
import {
  newNotebookPage,
  useAddNotebookPagesToState,
  useSelectedNotebookPageIdMap,
} from "../../page";

export const useInsertPageBlock = () => {
  const { selectedNotebookPageId, selectedNotebookPage } =
    useSelectedNotebookPageIdMap();
  const addNotebookPagesToState = useAddNotebookPagesToState();
  const { appId } = useAppIdMap();
  const insertBlock = useInsertBlock();
  return (config: { blockIndex: number; isDatabase?: boolean }) => {
    const { blockIndex, isDatabase } = config;
    const page = newNotebookPage({
      name: "New Page",
      folderId: selectedNotebookPageId!,
      appId: appId!,
      isDatabase,
    });
    const pageBlock = newNotePageBlock({
      parent: selectedNotebookPage!,
      child: page,
      blockIndex,
    });
    addNotebookPagesToState([page]);
    insertBlock({ blockIndex, block: pageBlock });
    [page, pageBlock].map(writeData);
  };
};
